import { createTheme } from '@mui/material/styles';
import typographySettings from './typography';
import { createTheming } from '@callstack/react-theme-provider';
import { deepmerge } from '@mui/utils';

import themes, { defaultTheme, lightTheme, palette } from './color';
import type { AppTheme } from './types';

const { ThemeProvider, useTheme } = createTheming<AppTheme>(themes['default'] as AppTheme);
export { ThemeProvider, useTheme };
export type { AppTheme };

export { palette };

const themeMapper: Record<string, typeof defaultTheme | typeof lightTheme> = {
  default: defaultTheme,
  light: lightTheme
};

export const createCustomTheme = (
  language: string,
  colorTheme: string,
  clientSlug: string,
  fontSize?: string
) => {
  const languageTypography = typographySettings(fontSize)[language as keyof ReturnType<typeof typographySettings>]?.default || {};
  const langSettings = typographySettings(fontSize)[language as keyof ReturnType<typeof typographySettings>] as Record<string, Record<string, unknown>> | undefined;
  const clientTypography = langSettings?.[clientSlug] || {};
  const mergedTheme = deepmerge(languageTypography, clientTypography);

  const colorConfig = themeMapper[colorTheme] || defaultTheme;

  return createTheme({
    palette: {
      background: {
        default: colorConfig.palette.background.default,
      },
      primary: {
        main: colorConfig.palette.primary.main,
      },
      secondary: {
        main: colorConfig.palette.secondary.main,
      },
    },
    typography: {
      htmlFontSize: 10,
      ...mergedTheme,
    },
    components: colorConfig.components,
  });
};
